import React from 'react'
import "./DotsLoader.less"

export default function DotsLoader({dotClass=''}) {
  
  return (
    <div className={`loader-animate ${dotClass}`}>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  )
}
